import { Component, OnInit, Input } from '@angular/core';
import { Client } from '../../interfaces/Client.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.css']
})
export class ConditionsComponent implements OnInit {

  public infouser: Client;
  @Input() infClient: Client;

  public isPropietario:boolean;

  constructor(
    private translate: TranslateService
  ) {
    this.isPropietario=false;
   }

  ngOnInit() {
    if(localStorage.getItem('infoClient')){
      this.infouser=JSON.parse(localStorage.getItem('infoClient'));
      if(this.infouser.category.id == '4'){
        this.isPropietario = true;
      }
    }
  }

  

  

}
